import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';

@Component({
  selector: 'app-increment-btn',
  standalone: true,
  imports: [CommonModule, MatRippleModule],
  templateUrl: './increment-btn.component.html',
  styleUrls: ['./increment-btn.component.scss']
})
export class IncrementBtnComponent implements OnInit {

  @Input() id = '';
  @Input() class = '';
  @Input() labelCount: number = 1;
  @Input() min: number;
  @Input() max: number;
  @Input() currency_symbol = '';
  @Input() themeConfig = {
    textColor: '',
    border: '',
    bgColor: '',
    height: '',
    fontSize: '',
    letterSpacing: '',
    iconSize: ''
  };
  @Output() onChange = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
  }

  add() {
    this.onChange.emit('+');
  }

  remove() {
    this.onChange.emit('-');
  }
}
